"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetConfigCommand = void 0;
const AbstractCommand_1 = require("../AbstractCommand");
class GetConfigCommand extends AbstractCommand_1.AbstractCommand {
    constructor(api, confType) {
        super(api);
        switch (confType) {
            case 'auth':
                this.endpoint = '/auth/config';
                break;
            case 'ui':
                this.endpoint = '/ui/config';
                break;
            default:
                this.endpoint = '';
        }
    }
    async exec() {
        return (await this.api.get(this.endpoint, false)).data;
    }
}
exports.GetConfigCommand = GetConfigCommand;
//# sourceMappingURL=GetConfigCommand.js.map